import numeral from 'numeral';

const currencySymbol = '$';
const decimal = 2;
const formatString = `${currencySymbol}0,0.${'0'.repeat(decimal)}`;

// This is different from formatCurrency in wagering and app, need to sync
const formatCurrency = (cents: number | string = 0, divisor: number = 100): string => {
	if (typeof cents !== 'number') {
		const sanitized = cents.replace(/\$/g, '');
		const parsedValue = parseFloat(sanitized);
		// eslint-disable-next-line no-restricted-globals
		if (isNaN(parsedValue)) return currencySymbol + cents;

		// eslint-disable-next-line no-param-reassign
		cents = parsedValue;
	}

	return numeral(cents / divisor).format(formatString);
};

export default formatCurrency;
